import { render, staticRenderFns } from "./Cards-company.vue?vue&type=template&id=5e0a9e1e"
import script from "./Cards-company.vue?vue&type=script&lang=js"
export * from "./Cards-company.vue?vue&type=script&lang=js"
import style0 from "./Cards-company.vue?vue&type=style&index=0&id=5e0a9e1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports